import {MovePagesArgs} from '~shared/schema/wiki/actions/pages-move';
import {
    GetOperationStatusArg,
    GetOperationStatusResponse,
} from '~shared/schema/wiki/actions/operations';

import {sleep} from '~ui/utils';

import {sdk} from '../sdk';

export async function movePagesRequest({operations, dryRun}: MovePagesArgs) {
    const result = await sdk.wiki.movePages({
        operations,
        dryRun,
    });

    if (result.dry_run) return;

    return pollOperation(result.operation.id, sdk.wiki.getMoveOperationStatus);
}

export async function pollOperation<Result extends object>(
    taskId: string,
    pollFn: (args: GetOperationStatusArg) => Promise<GetOperationStatusResponse<Result>>,
): Promise<Result> {
    let result: Result | undefined;

    while (!result) {
        const operation = await pollFn({taskId});

        if (operation.status === 'success') {
            result = operation.result;
            break;
        }

        if (operation.status === 'failed') {
            throw new Error('operation failed');
        }

        await sleep(2000);
    }

    return result;
}
